import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { getOrderDetails } from "services/shopify-account";
import * as styles from "./styles.mod.scss";
import Money from "components/money";
import Loader from "components/loader";
import { ChevronDown } from "react-bootstrap-icons";
import locale from "locales";

const LineItem = (props) => {
  const { lineItem } = props;
  return <div className={styles.lineItem}>
    {
      lineItem?.variant?.image?.src && (
        <div className={styles.variantImage}>
          <img src={lineItem.variant?.image?.src} alt={lineItem?.variant?.image?.alt} />
        </div>
      )
    }
    <div className={styles.lineItemDescription}>
      <div>
        <strong>{lineItem.variant?.title}</strong>
        <span>{locale.account.orders.amount} {lineItem.quantity}</span>
        {
          !lineItem?.variant && <span className={styles.error}>{locale.account.orders.productNoLongerExist}</span>
        }
        {/* <span>{locale.account.orders.article}: {lineItem.variant?.sku}</span> */}
      </div>
      {/* <strong>{locale.account.orders.total}: <Money value={lineItem.discountedTotalPrice.amount} currency={lineItem.discountedTotalPrice.currencyCode} /></strong> */}
    </div>
  </div>;
};

const SingleLineItem = (props) => {
  const { lineItem } = props;
  return <div className={styles.singleLineItem}>
    <div className={styles.variantImage}>
      <img src={lineItem.imgSrc} alt={lineItem?.imgSrc.alt} />
    </div>
    <div className={styles.lineItemDescription}>
      <div>
        <strong>{lineItem.productTitle}</strong>
        <span>{locale.account.orders.amount} {lineItem.quantity}</span>
        <span>{locale.account.orders.article}: {lineItem.sku}</span>
      </div>
    </div>
  </div>;
};

const Order = (props) => {
  const { order, open, setOpen, standalone } = props;
  const [loading, setLoading] = useState(true);
  const [orderInfo, setOrderInfo] = useState({});
  const [expandedChild, setExpandedChild] = useState(null);
  const lineItems = order.lineItems.edges.map((edge) => edge.node);
  const summaryStatus = order?.summary?.status;

  const expandOrder = async () => {
    if (order.id !== open) {
      setLoading(true);
      setOpen(order.id);
      const orderDetails = standalone ? order.summary : await getOrderDetails(order.orderNumber);
      setOrderInfo(orderDetails);
      setLoading(false);
    } else {
      setOpen({});
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkAndExpand = async () => {
      if (props?.alwaysOpen) {
        await expandOrder();
      }
    };

    checkAndExpand();
  }, []);


  const orderSteps = [
    {
      status: "READY_TO_PROCESS",
      title: locale.account.orders.orderReceived,
      subtitle: locale.account.orders.orderReceivedSub,
      cta: "BESTELLUNG FERFOLGEN",
      stepNumber: 1,
      children: lineItems
    },
    {
      status: "PROCESSING",
      title: locale.account.orders.processing,
      subtitle: locale.account.orders.processingSub,
      cta: "BESTELLUNG FERFOLGEN",
      stepNumber: 2,
      children: lineItems
    },
    {
      status: "SHIPPING",
      title: locale.account.orders.shipped,
      subtitle: locale.account.orders.shippedSub,
      cta: "BESTELLUNG FERFOLGEN",
      stepNumber: 3,
      children: lineItems
    },
    {
      status: "DELIVERED",
      title: locale.account.orders.delivered,
      subtitle: locale.account.orders.deliveredSub,
      cta: "BESTELLUNG FERFOLGEN",
      stepNumber: 4,
      children: lineItems
    },
  ];

  const orderStatus = {
    "RECEIVED": "BESTELLUNG ERHALTEN",
    "PROCESSING": "IN BEARBEITUNG",
    "RETURNING": "WIRD ZURÜCKGESENDET",
    "SHIPPING": "VERSANDT",
    "SHIPPED": "VERSANDFERTIG",
    "DELIVERED": "GELIEFERT",
    "UNPAID": "UNBEZAHLT",
    "READY_TO_PROCESS": "BEREIT ZUR BEARBEITUNG",
    "OTHER": "WARTESTELLUNG",
    "EXCEPTION": "AUSNAHME",
    "RETURNED": "RETOURNIERT",
    "CANCELLED": "STORNIERT",
    "DIGITAL": "Du hast einen Service bestellt. Bitte wende dich bei Fragen an den Kundenservice."
  };

  const currentStep = (status) => orderInfo.status === status ? styles.stepNumberCurrent : "";
  const toggleExpandedChild = (step) => setExpandedChild(expandedChild ? null : step);
  const hasChildOrders = (order) => order?.childOrders?.length !== 0;

  const ExpandedInfo = ({ step }) => (
    <>
      {
        orderInfo.status === step.status && hasChildOrders(orderInfo) && (
          <button onClick={() => toggleExpandedChild(step.stepNumber)} className={styles.stepButton}>{step.cta}</button>
        )
      }
      {
        expandedChild === step.stepNumber && hasChildOrders(orderInfo) && orderInfo.childOrders.map((order, index) => (
          <div className={styles.expandedInfo} key={index}>
            <div className={styles.expandedItems}>

              <span className={styles.expandedTitle}>Sendung {index + 1}
                {order.trackings[0] && <span> <a className={styles.link} target="_BLANK" rel="noreferrer" href={order.trackings[0]?.trackingUrl}>{locale.pages.contact.trackingURL}</a></span>}
              </span>
              {
                order.items.map((item) => <SingleLineItem lineItem={item} key={item?.id} />)
              }
            </div>
            <StepProgress title="Versandstatus" />
          </div>
        ))
      }
    </>
  );

  const StepProgress = ({ title, withExpandedInfo }) => (
    <ul className={styles.orderSteps}>
      <span className={styles.expandedTitle}>{title}</span>
      {
        orderSteps.map((o) => o.status).includes(orderInfo?.status) && orderSteps.map((step, index) => (
          <li key={index} className={`${expandedChild === step.stepNumber ? styles.currentExpanded : ""} ${withExpandedInfo ? "" : styles.lastExpanded}`}>
            <div className={`${styles.stepInfo} ${currentStep(step.status)} ${hasChildOrders(orderInfo) ? styles.hasButton : ""}`}>
              <div className={styles.stepNumber}>
                {step.stepNumber}
              </div>
              <div className={styles.stepDescription}>
                <div>{step.title}</div>
                {!hasChildOrders(orderInfo) && step.stepNumber === 3 && orderInfo.trackings[0] ? <span>{step.subtitle} - <a className={styles.link} target="_BLANK" rel="noreferrer" href={orderInfo.trackings[0]?.trackingUrl}> {orderInfo.trackings[0]?.trackingId} </a> </span> : <span>{step.subtitle}</span>}
              </div>
            </div>
            {withExpandedInfo && <ExpandedInfo step={step} />}
          </li>
        ))
      }
    </ul>
  );

  const currentStatus = (orderInfo) => orderStatus[orderInfo?.status] || orderStatus[summaryStatus] || orderStatus["OTHER"];

  return (
    <Card key={order.id} className={styles.card}>
      <Accordion.Toggle as={Card.Header} eventKey={order.id}
        onClick={expandOrder} className={styles.cardHeader}>
        <div className={styles.orderDate}>
          <strong>{new Date(order.processedAt).toLocaleDateString()} </strong>
          <strong>#OL{order.orderNumber}</strong><br />
          <span className={styles.sub}>{lineItems?.length} {locale.account.orders.article}</span>
        </div>
        <div className={styles.orderTotal}>
          <strong>{summaryStatus && currentStatus(orderInfo)}</strong><br />
          <span className={styles.sub}>
            <Money
              value={order.totalPriceV2.amount}
              currency={order.totalPriceV2.currencyCode} />
          </span>
        </div>
        <span className={`${styles.accordionIcon} ${open !== order.id ? styles.open : ""}`}><ChevronDown /></span>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={order.id}>
        <Card.Body>
          {
            loading ? <Loader width="100%" /> : (
              <div className={styles.orderBody}>
                <StepProgress withExpandedInfo={true} />
                <h4>{locale.account.orders.overview}</h4>
                {lineItems.map((lineItem) => <LineItem lineItem={lineItem} key={lineItem.variant?.id} />)}
                {/* <Money
                  value={order.subtotalPriceSet.presentmentMoney.amount} 
                  currency={order.subtotalPriceSet.presentmentMoney.currencyCode} /> */}
              </div>
            )
          }
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default Order;
